module.exports = __webpack_public_path__ + "static/media/ic_graphic_end_session@2x.7539d80c.png";